<template>
    <div v-show="modelValue" class="fixed top-0 w-full h-full bg-transparent-basic-3 z-[80] flex justify-center items-center">
        <div class="relative bg-white rounded-4 w-[300px] p-4 pb-5 overflow-hidden shadow-modal transform transition-all flex flex-col items-center">
                <div class="mx-auto flex-shrink-0 flex items-center justify-center h-12 w-12 pt-[1px] rounded-full" :class="{ 'bg-accent-red-1': warn, 'bg-accent-green-1': !warn }" >
                    <ExclamationIcon v-if="warn" class="h-6 w-6 text-accent-red-3" aria-hidden="true" />
                    <CheckIcon v-else class="h-6 w-6 text-accent-green-3" aria-hidden="true" />
                </div>
            <div class="mt-3 text-center">
                <h3 class="font-body-md-medium">{{ name }}</h3>
                <div class="mt-2 font-body-sm-semibold text-content-basic-2">
                    <slot />
                </div>
            </div>
            <div class="mt-4 flex justify-center gap-2 w-full">
                <DesignButton v-if="showButton" class="w-full" :btnType="buttonColor" btnVariant="FILL" :btnText="buttonText" @click-event="buttonEvent" />
            </div>
        </div>
    </div>
</template>

<script setup>
import { defineProps, defineEmits } from 'vue';
import { CheckIcon, ExclamationIcon } from '@heroicons/vue/outline';
import DesignButton from '../design-system/design-button.vue';

components: {
    DesignButton
}

defineProps({
    modelValue: Boolean,
    name: String,
    buttonText: String,
    buttonColor: String,
    warn: Boolean,
    showButton: {
        type: Boolean,
        default: true,
    },
});

const emit = defineEmits(['buttonEvent']);

function buttonEvent() {
    emit('buttonEvent');
}
</script>
